// Add CSS
require('vue-multiselect/dist/vue-multiselect.min.css');
require('bootstrap/dist/css/bootstrap.min.css');
require('bootstrap-vue/dist/bootstrap-vue.css');
require('pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css');
require('font-awesome/css/font-awesome.min.css');
require('@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css');
require('@/assets/css/base.css');
require('@/assets/css/main.css');
require('moment/locale/id');

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from '@/App';
import router from '@/router';
import store from '@/store.js';
import BootstrapVue from 'bootstrap-vue';
import VueToastr from '@deveodk/vue-toastr';
import VueMoment from 'vue-moment';
import VueCurrencyFilter from 'vue-currency-filter';

const moment = require('moment');

Vue.config.productionTip = false;

Vue.use(BootstrapVue);
Vue.use(VueToastr, {
    defaultPosition: 'toast-top-right',
    defaultTimeout: 3000
});
Vue.use(VueCurrencyFilter, {
    symbol: 'Rp'
});
Vue.use(VueMoment, { moment });

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    components: {App},
    template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js